// LanguageSwitcherDropdown.tsx
import { AppDropdown } from 'components/AppDropdown/AppDropdown'
import React from 'react'
import { useTranslation } from 'react-i18next'

// import { LANG_OPTIONS } from './i18nLanguages'
export const LANG_OPTIONS = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
  // { code: 'ar', label: 'العربية' },
  // { code: 'es', label: 'Español' },
  // { code: 'zh', label: '中文' }, // Добавили китайский (упрощённый)
]
interface ILangOption {
  code: string
  label: string
}

export const LanguageSwitcherDropdown = () => {
  const { i18n, t } = useTranslation()

  const currentLang =
    LANG_OPTIONS.find((l) => l.code === i18n.language) || LANG_OPTIONS[0]

  const handleChange = (lang: ILangOption) => {
    i18n.changeLanguage(lang.code)
    localStorage.setItem('i18nextLng', lang.code)
    document.documentElement.dir = lang.code === 'ar' ? 'rtl' : 'ltr'
  }

  return (
    <AppDropdown<ILangOption, 'label'>
      data={LANG_OPTIONS}
      value={currentLang}
      onChange={handleChange}
      placeholder={t('Выберите язык')}
      propToShowInList="label"
      propToShowInInput="label"
      fullWidth
      withTranslate={false}
    />
  )
}
